import React from "react";

const Wrapper = (Component: React.FC) => () => {
	return (
		<div className="content">
			<Component />
		</div>
	);
};

export default Wrapper;
